import InstallationPhasesManager from '@/components/admin/InstallationPhasesManager';

export default function InstallationPhases() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Installation Phase Settings</h1>
        <p className="text-muted-foreground mt-2">
          Configure default product auto-selection for each installation phase in sales presentation mode
        </p>
      </div>
      
      <InstallationPhasesManager />
    </div>
  );
}
